module.exports = __webpack_public_path__ + "stylesheets/wave-template-item_cfbb0ee622df1b2113ed1b6fccafe487.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-template-item.less
// module id = aTCW
// module chunks = 51